import { ConsommationFlotteList } from '@services/interfaces/generated/YSER-v1';
import { transformUnit } from '@shared/misc/helpers/data';
import { useMemo } from 'react';
import { ConsommationFlotteRecap, UseBilanCarboneProps } from './type';

const useData = (data: ConsommationFlotteList | undefined): UseBilanCarboneProps => {
  const last = useMemo<ConsommationFlotteRecap | undefined>(() => {
    if (data?.resultsCount) {
      const result = data.items[data.resultsCount - 1];
      const calculatedData = transformUnit(result.data, 'data');
      return { ...result, data: calculatedData, co2eq: transformUnit(result.co2eq, 'co2eq') };
    }
    return undefined;
  }, [data]);

  return {
    last,
  };
};

export default useData;
